import React, { useState, useEffect, useCallback } from 'react';
import { format, subDays } from 'date-fns';
import ReportLayout, { ReportTable, usePagination, fmtId } from './ReportLayout';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const COLS = [
  { key:'staff_id',         label:'Staff ID',         render: fmtId },
  { key:'staff_name',       label:'Staff Name' },
  { key:'_team',            label:'Team',          render: () => '–' },
  { key:'_facility',        label:'Facility',      render: () => '–' },
  { key:'pay_group',        label:'Pay Group' },
  { key:'pay_review_date',  label:'Pay Review Date', render: v => v ? format(new Date(v), 'd MMM yyyy') : '–' },
  { key:'role',             label:'Role', render: v => <span className="capitalize">{v||'–'}</span> },
  { key:'employment_type',  label:'Employment Type' },
  { key:'start_date',       label:'Start Date', render: v => v ? format(new Date(v), 'd MMM yyyy') : '–' },
  { key:'industry_award',   label:'Industry Award',  render: () => '–' },
  { key:'award_level',      label:'Award Level',     render: () => '–' },
  { key:'_award2',          label:'Award Level 2',   render: () => '–' },
];

export default function PayReviewDate() {
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [startDate, setStart] = useState(format(subDays(new Date(), 730), 'yyyy-MM-dd'));
  const [endDate, setEnd]     = useState(format(new Date(Date.now() + 365*86400000), 'yyyy-MM-dd'));
  const pagination = usePagination(data);

  const load = useCallback(() => {
    setLoading(true);
    api.get(`/reports/pay-review?start_date=${startDate}&end_date=${endDate}`)
      .then(r => { setData(r.data || []); pagination.reset(); })
      .catch(() => toast.error('Failed to load'))
      .finally(() => setLoading(false));
  }, [startDate, endDate]);

  useEffect(() => { load(); }, [load]);

  const chips = [{ label:'Date Range', value:`${startDate} - ${endDate}` }];

  return (
    <ReportLayout title="Pay Review Date" data={data} filename="pay_review_date"
      columns={COLS} activeChips={chips} showFiltersPanel={showFilters} onToggleFilters={() => setShowFilters(v=>!v)}
      filters={
        <div className="flex flex-wrap gap-4">
          <div><label className="block text-xs font-semibold text-slate-500 mb-1">Start Date</label>
            <input type="date" value={startDate} onChange={e => setStart(e.target.value)} className="input-field !w-auto text-sm"/></div>
          <div><label className="block text-xs font-semibold text-slate-500 mb-1">End Date</label>
            <input type="date" value={endDate} onChange={e => setEnd(e.target.value)} className="input-field !w-auto text-sm"/></div>
          <div className="flex items-end"><button onClick={load} className="btn-primary text-sm px-4 py-2">Apply</button></div>
        </div>
      }>
      <ReportTable columns={COLS} data={data} loading={loading} pagination={pagination}/>
    </ReportLayout>
  );
}
